function calculateAge(month, day, year) {
  const todayDate = new Date();
  const todayYear = todayDate.getFullYear();
  const todayMonth = todayDate.getMonth();
  const todayDay = todayDate.getDate();
  let age = todayYear - year;

  if (todayMonth < (month - 1)) {
    age -= 1;
  }
  if (((month - 1) === todayMonth) && (todayDay < day)) {
    age -= 1;
  }
  return age;
}

const minimumAge = (value) => {
  if (!value) {
    return false;
  }
  const dateArray = value.split('/');
  const day = parseInt(dateArray[0], 10);
  const month = parseInt(dateArray[1], 10);
  const year = parseInt(dateArray[2], 10);
  return calculateAge(month, day, year) >= 18;
};

export default minimumAge;
